/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DocumentoBozzaSpuntaForm { 
    tipo: DocumentoBozzaSpuntaFormTipoEnum;
    testo_it: string;
}
export enum DocumentoBozzaSpuntaFormTipoEnum {
    ACCETTO = 'ACCETTO',
    HO_LETTO = 'HO_LETTO',
    ACCONSENTO = 'ACCONSENTO'
};



